import { InputHTMLAttributes } from "react";
import cn from "classnames";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  title?: string;
  variant?: "sm" | "md";
}

export default function Input({
  className,
  title,
  variant = "md",
  ...props
}: InputProps) {
  return (
    <>
      {title && <p className="font-medium text-sm pb-1 m-0">{title}</p>}
      <input
        className={cn(
          "input input-bordered focus:outline-none focus:border-blue-500 border-grey-500 dark:border-base-content/40 max-w-xs bg-grey-50 dark:bg-base-200 transition-colors disabled:bg-grey-50 dark:disabled:bg-base-200 disabled:border-grey-500 dark:disabled:border-base-content/40 disabled:text-gray-600 dark:disabled:text-base-content/70",
          variant === "sm" &&
            "bg-base-100 h-8 p-3 border-grey-100 dark:border-base-300 focus:border-blue-500 text-sm",
          className
        )}
        {...props}
      />
    </>
  );
}
